import { takeEvery, put, select } from 'redux-saga/effects';
import * as actions from '../actions';
import * as selectors from '../selectors';

export function* preloadShowcaseData() {
  yield put(actions.adSlot.getAdSlots());
  const firms = yield select(selectors.firms.firms);
  if (!firms?.length) {
    yield put(actions.firm.getFirms());
  }
  yield put(actions.listing.getListings());
  // yield put(actions.repActions.getReps());
}

export function* showcaseSagas() {
  yield takeEvery(actions.showcase.preloadShowcaseData, preloadShowcaseData);
}
